import { render, staticRenderFns } from "./CourseFailPassReport.vue?vue&type=template&id=4ff4d86a&scoped=true"
import script from "./CourseFailPassReport.vue?vue&type=script&lang=js"
export * from "./CourseFailPassReport.vue?vue&type=script&lang=js"
import style0 from "./CourseFailPassReport.vue?vue&type=style&index=0&id=4ff4d86a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff4d86a",
  null
  
)

export default component.exports